import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/henry/yuelai-engine-blog-web/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/builds/henry/yuelai-engine-blog-web/layouts/error.vue").then(m => m.default || m))
}